import { path } from 'd3-path'
import Symbol2d from '../2d.js'
import tipLock from './helpers/tip-lock.js'

export default class Tag extends Symbol2d {

  static mixins = [tipLock]

  handles = [{
    defaults: [.7, .0],
    constraints: [
      [0, 1], null
    ],
    cursor: 'ew-resize'
  }]

  path (dimensions) {
    const _path = path()

    _path.moveTo(0, 0)
    _path.lineTo(Math.max(dimensions.width - this.tipHeight, 0), 0)
    _path.lineTo(dimensions.width, dimensions.height / 2)
    _path.lineTo(Math.max(dimensions.width - this.tipHeight, 0), dimensions.height)
    _path.lineTo(0, dimensions.height)
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    // Notice this isn't using `this.tipHeight` because we want to use the current
    // tipHeight that's being rendered, not the "ideal" tipHeight
    const tipHeight = dimensions.width - dimensions.width * handles[0][0]
    const width = dimensions.width - tipHeight

    return {
      center: [(dimensions.width - tipHeight) / 2, dimensions.center[1]],
      width: width,
      height: dimensions.height
    }
  }

}
